export default __webpack_public_path__ + "static/media/websiteIcon.6dd18450.svg";